<div class="bg-white rounded-2xl border border-fuchsia-100 shadow-sm overflow-hidden">
  <!-- Container header - opens the container's own page from the list -->
  <div class="flex flex-row items-center justify-between gap-4 flex-wrap px-5 py-4 border-b border-gray-100 bg-fuchsia-50/40"
    [ngClass]="linkToDetail ? 'cursor-pointer hover:bg-fuchsia-50 transition-colors' : ''"
    [attr.role]="linkToDetail ? 'link' : null" [attr.tabindex]="linkToDetail ? 0 : null"
    (click)="openDetail()" (keydown.enter)="openDetail()">
    <div class="flex items-center gap-3 flex-wrap min-w-0">
      <span class="h-10 w-10 rounded-xl bg-neutral-900 text-amber-400 flex items-center justify-center flex-shrink-0"><mat-icon>view_in_ar</mat-icon></span>
      <div class="min-w-0">
        <div class="font-mono font-bold text-gray-900 text-base">{{ card.containerNo || 'Container (no number)' }}</div>
        <div class="text-xs text-gray-500 flex items-center gap-1.5 flex-wrap">
          <a class="font-semibold text-fuchsia-700 hover:underline" [routerLink]="['/shipments/edit', card.shipmentId]" (click)="$event.stopPropagation()" matTooltip="Open the shipment">{{ card.shipmentReference }}</a>
          @if (card.shippingLine || card.vesselDetails) { <span class="text-gray-300">&middot;</span> {{ card.shippingLine }} {{ card.vesselDetails }} }
          @if (card.clearedAt) { <span class="text-gray-300">&middot;</span> <span class="text-violet-700 font-semibold">cleared {{ card.clearedAt | date: 'd MMM' }}</span> }
        </div>
      </div>
      <span class="text-xs font-semibold px-2.5 py-1 rounded-full bg-fuchsia-600 text-white">{{ card.store }}</span>
      @for (o of containerOrders(card); track o.reference) {
      <span class="text-xs font-semibold px-2 py-0.5 rounded-md bg-amber-50 text-amber-800 border border-amber-100" [matTooltip]="o.supplierName || ''">{{ o.reference }}</span>
      }
    </div>
    <div class="flex items-center gap-2 text-xs">
      <span class="font-semibold px-2.5 py-1 rounded-full bg-lime-50 text-lime-800 border border-lime-300">Delivered</span>
      <span class="text-gray-400">{{ expectedUnits(card) }} unit{{ expectedUnits(card) === 1 ? '' : 's' }} expected</span>
    </div>
  </div>

  <!-- Lines -->
  <div class="overflow-x-auto">
  <table class="w-full text-sm">
    <thead>
      <tr class="text-left text-xs font-semibold text-gray-400 uppercase tracking-wide">
        <th class="px-5 py-2.5">Product</th>
        <th class="px-3 py-2.5">Purchase order</th>
        <th class="px-3 py-2.5 text-right w-28">In container</th>
        <th class="px-3 py-2.5 text-right w-32">Arrived</th>
        <th class="px-3 py-2.5 text-right w-32" title="Of what arrived - written off as scrap">Damaged</th>
        <th class="px-3 py-2.5 text-right w-32" title="Of what arrived - sent back, stays outstanding on the PO">Return to supplier</th>
        <th class="px-5 py-2.5 text-right w-28">Difference</th>
      </tr>
    </thead>
    <tbody>
      @for (l of card.lines; track l.id) {
      <tr class="border-t border-gray-50">
        <td class="px-5 py-3">
          <div class="font-medium text-gray-900">{{ l.productName }}</div>
          @if (l.sku) { <a class="text-xs text-gray-400 font-mono hover:text-fuchsia-700 hover:underline" [routerLink]="['/inventory']" [queryParams]="{ q: l.sku }" target="_blank" rel="noopener">{{ l.sku }}</a> }
          @if (!l.onPo) { <div class="text-[11px] font-semibold text-red-600 mt-0.5">Not found on {{ l.poReference }} - fix the shipment line first</div> }
        </td>
        <td class="px-3 py-3">
          <div class="text-xs font-semibold text-gray-700">{{ l.poReference }}</div>
          @if (l.outstandingOnPo !== null) { <div class="text-[11px] text-gray-400">{{ l.outstandingOnPo }} still outstanding</div> }
        </td>
        <td class="px-3 py-3 text-right text-gray-700 font-semibold">{{ l.expected }} <span class="text-[11px] font-normal text-gray-400">{{ l.unitOfMeasure }}</span></td>
        <td class="px-3 py-3 text-right">
          <input type="number" min="0"
            class="w-24 px-2.5 py-2 rounded-lg border text-sm text-right font-semibold outline-none focus:border-fuchsia-400 focus:ring-2 focus:ring-fuchsia-100"
            [ngClass]="difference(card, l.id, l.expected) !== 0 ? 'border-amber-300 bg-amber-50' : 'border-gray-200'"
            [(ngModel)]="card.arrived[l.id]" [attr.aria-label]="'Units of ' + l.productName + ' that arrived'" />
        </td>
        <td class="px-3 py-3 text-right align-top">
          <input type="number" min="0" step="1" placeholder="0"
            class="w-24 px-2.5 py-2 rounded-lg border text-sm text-right font-semibold outline-none focus:border-red-400 focus:ring-2 focus:ring-red-100"
            [ngClass]="damageError(card, l.id) ? 'border-red-400 bg-red-50' : (card.damaged[l.id] ? 'border-red-300 bg-red-50 text-red-700' : 'border-gray-200')"
            [(ngModel)]="card.damaged[l.id]" [attr.aria-label]="'Damaged units of ' + l.productName" />
          @if (damageError(card, l.id); as err) {
          <div class="text-[10px] font-semibold text-red-600 mt-1">{{ err }}</div>
          } @else if (card.damaged[l.id]) {
          <input type="text" maxlength="300" placeholder="What's wrong? (optional)"
            class="mt-1.5 w-40 px-2 py-1 rounded-md border border-red-200 bg-white text-[11px] outline-none focus:border-red-400 focus:ring-2 focus:ring-red-100"
            [(ngModel)]="card.damageNote[l.id]" [attr.aria-label]="'Damage note for ' + l.productName" />
          }
        </td>
        <td class="px-3 py-3 text-right align-top">
          <input type="number" min="0" placeholder="0"
            class="w-24 px-2.5 py-2 rounded-lg border text-sm text-right font-semibold outline-none focus:border-sky-400 focus:ring-2 focus:ring-sky-100"
            [ngClass]="returnError(card, l.id) ? 'border-red-400 bg-red-50' : (card.returned[l.id] ? 'border-sky-300 bg-sky-50 text-sky-800' : 'border-gray-200')"
            [(ngModel)]="card.returned[l.id]" [attr.aria-label]="'Units of ' + l.productName + ' returned to the supplier'" />
          @if (returnError(card, l.id); as err) {
          <div class="text-[10px] font-semibold text-red-600 mt-1">{{ err }}</div>
          } @else if (card.returned[l.id]) {
          <input type="text" maxlength="300" placeholder="Why? (optional)"
            class="mt-1.5 w-40 px-2 py-1 rounded-md border border-sky-200 bg-white text-[11px] outline-none focus:border-sky-400 focus:ring-2 focus:ring-sky-100"
            [(ngModel)]="card.returnNote[l.id]" [attr.aria-label]="'Return reason for ' + l.productName" />
          }
        </td>
        <td class="px-5 py-3 text-right font-semibold">
          @if (difference(card, l.id, l.expected); as d) {
          <span [ngClass]="d < 0 ? 'text-red-600' : 'text-amber-700'">{{ d > 0 ? '+' : '' }}{{ d }}</span>
          } @else {
          <mat-icon class="!text-[18px] !h-[18px] !w-[18px] text-green-600 align-middle">check_circle</mat-icon>
          }
        </td>
      </tr>
      }
    </tbody>
  </table>
  </div>

  <!-- Actions -->
  <div class="flex flex-row items-center justify-between gap-3 px-5 py-3.5 border-t border-gray-100 bg-gray-50/60 flex-wrap">
    <div class="flex items-center gap-3 text-xs">
      @if (discrepancies(card)) {
      <span class="font-semibold text-amber-800">{{ discrepancies(card) }} line{{ discrepancies(card) === 1 ? '' : 's' }} differ</span>
      <button class="font-semibold text-gray-500 hover:text-gray-800 underline" (click)="resetToExpected(card)">Reset to expected</button>
      } @else if (!damagedUnits(card) && !returnedUnits(card)) {
      <span class="text-green-700 font-semibold flex items-center gap-1"><mat-icon class="!text-[16px] !h-4 !w-4">check_circle</mat-icon>Everything as expected</span>
      }
      @if (damagedUnits(card)) {
      <span class="inline-flex items-center gap-1 font-semibold text-red-700 bg-red-50 border border-red-200 rounded-full px-2.5 py-1">
        <mat-icon class="!text-[14px] !h-3.5 !w-3.5">broken_image</mat-icon>{{ damagedUnits(card) }} damaged &middot; written off as scrap
      </span>
      }
      @if (returnedUnits(card)) {
      <span class="inline-flex items-center gap-1 font-semibold text-sky-800 bg-sky-50 border border-sky-200 rounded-full px-2.5 py-1">
        <mat-icon class="!text-[14px] !h-3.5 !w-3.5">assignment_return</mat-icon>{{ returnedUnits(card) }} back to the supplier
      </span>
      }
    </div>
    <button
      class="flex items-center gap-2 px-5 py-2.5 rounded-xl bg-fuchsia-600 text-white font-semibold text-sm shadow-md shadow-fuchsia-200 hover:bg-fuchsia-700 active:scale-[0.98] transition-all disabled:opacity-50"
      [disabled]="card.saving || hasDamageErrors(card)" (click)="validateContainer(card)">
      @if (card.saving) { <mat-spinner diameter="16"></mat-spinner> } @else { <mat-icon class="!text-[18px] !h-[18px] !w-[18px]">fact_check</mat-icon> }
      Validate &amp; receive {{ goodUnits(card) }} unit{{ goodUnits(card) === 1 ? '' : 's' }}@if (setAsideLabel(card); as extra) { <span class="font-normal opacity-80">({{ extra }})</span> }
    </button>
  </div>
</div>
